import { DRIVE_FOLDER_TYPE_TRANSLATED, EMPTY_FOLDER_MESSAGES } from '@/components/enmon/files/constants';
import { ModelFilesGallery } from '@/components/enmon/files/model_library_files_gallery';
import type { DriveFolderType } from '@enmon/commons/lib/tools';
import { Card } from 'components';
import type { FC } from 'react';
import { useModuleDetailContext } from '../store';
import { MeterModelFilesCardType } from '@/routes/reseller-data/routes/model-library/routes/models/routes/detail/constants';

interface MeterModuleFilesCardProps {
  folderType: DriveFolderType;
}

// Read-only, like the model's files: the module's Drive folder ({Manufacturer}/Meter Modules/{name}) is filled outside
// the UI. Fills its column: overview, photos and documents are the same height.
export const MeterModuleFilesCard: FC<MeterModuleFilesCardProps> = ({ folderType }) => {
  const { module } = useModuleDetailContext();

  return (
    <Card
      style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
      styles={{ body: { flex: 1 } }} // the body fills the stretched card: the empty state centres in it
      title={DRIVE_FOLDER_TYPE_TRANSLATED[folderType]}
    >
      <ModelFilesGallery
        enablePreview
        module={module}
        folderType={folderType}
        emptyMessage={EMPTY_FOLDER_MESSAGES[folderType]}
        source={MeterModelFilesCardType.Module}
      />
    </Card>
  );
};
